/* eslint-disable @typescript-eslint/no-explicit-any */

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & Record<string, any>;
